// Generat automat din README.md
import React from 'react';
import { BarChart, TrendingUp, PieChart, Calendar } from 'lucide-react';
import Card from '../../components/Card';

const RapoarteFinanciare = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Rapoarte Financiare</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">
          Analize financiare complete cu vizualizări interactive și export automat
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card title="Venituri Luna" icon={TrendingUp}>
          <div className="text-2xl font-bold text-green-600">89,450 RON</div>
          <div className="text-sm text-green-600">+15% vs luna trecută</div>
        </Card>
        <Card title="Cheltuieli Luna" icon={BarChart}>
          <div className="text-2xl font-bold text-red-600">45,230 RON</div>
          <div className="text-sm text-red-600">+8% vs luna trecută</div>
        </Card>
        <Card title="Profit Net" icon={PieChart}>
          <div className="text-2xl font-bold text-primary-600">44,220 RON</div>
          <div className="text-sm text-green-600">+22% vs luna trecută</div>
        </Card>
        <Card title="Cash Flow" icon={Calendar}>
          <div className="text-2xl font-bold text-blue-600">67,890 RON</div>
          <div className="text-sm text-blue-600">Pozitiv acest trimestru</div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="Rapoarte Disponibile">
          <div className="space-y-4">
            <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <div className="flex items-center justify-between mb-2">
                <h4 className="font-semibold">Bilanț Contabil</h4>
                <span className="text-xs text-gray-500">Trimestrial</span>
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                Situația financiară completă cu active, pasive și capitaluri proprii
              </p>
              <button className="btn-primary text-sm">Generează Raport</button>
            </div>
            
            <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <div className="flex items-center justify-between mb-2">
                <h4 className="font-semibold">Cont de Profit și Pierderi</h4>
                <span className="text-xs text-gray-500">Lunar</span>
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                Analiza veniturilor, cheltuielilor și profitabilității
              </p>
              <button className="btn-primary text-sm">Generează Raport</button>
            </div>
            
            <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <div className="flex items-center justify-between mb-2">
                <h4 className="font-semibold">Fluxul de Trezorerie</h4>
                <span className="text-xs text-gray-500">Săptămânal</span>
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                Monitorizarea intrărilor și ieșirilor de numerar
              </p>
              <button className="btn-primary text-sm">Generează Raport</button>
            </div>
          </div>
        </Card>

        <Card title="Analize Predictive">
          <div className="space-y-4">
            <div className="p-4 border-l-4 border-blue-500 bg-blue-50 dark:bg-blue-900/20">
              <h4 className="font-semibold text-blue-800 dark:text-blue-200">
                Predicție Venituri Q2
              </h4>
              <p className="text-blue-700 dark:text-blue-300 text-sm mt-1">
                Estimare: 125,000 - 135,000 RON
              </p>
              <p className="text-xs text-blue-600 dark:text-blue-400 mt-2">
                Bazat pe tendințele din ultimele 12 luni
              </p>
            </div>

            <div className="p-4 border-l-4 border-green-500 bg-green-50 dark:bg-green-900/20">
              <h4 className="font-semibold text-green-800 dark:text-green-200">
                Optimizare Cheltuieli
              </h4>
              <p className="text-green-700 dark:text-green-300 text-sm mt-1">
                Potențial de economisire: 8,500 RON
              </p>
              <p className="text-xs text-green-600 dark:text-green-400 mt-2">
                Reducerea costurilor operaționale
              </p>
            </div>

            <div className="p-4 border-l-4 border-yellow-500 bg-yellow-50 dark:bg-yellow-900/20">
              <h4 className="font-semibold text-yellow-800 dark:text-yellow-200">
                Alertă Cash Flow
              </h4>
              <p className="text-yellow-700 dark:text-yellow-300 text-sm mt-1">
                Atenție la perioada 15-25 Aprilie
              </p>
              <p className="text-xs text-yellow-600 dark:text-yellow-400 mt-2">
                Planificare plăți furnizori necesară
              </p>
            </div>
          </div>
        </Card>
      </div>

      <Card title="Grafice Interactive" subtitle="Vizualizare date financiare">
        <div className="h-64 bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center">
          <div className="text-center">
            <BarChart className="w-16 h-16 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-500">Grafice interactive vor fi afișate aici</p>
            <p className="text-sm text-gray-400 mt-2">Implementare cu Chart.js sau D3.js</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default RapoarteFinanciare;